import { Vector2CanvasNormalized } from '@typings/vectors';

export interface ILpCanvasRendererContext {
  registerPositionTransformer(
    transformer: (current: Vector2CanvasNormalized, origin: Vector2CanvasNormalized) => Vector2CanvasNormalized,
  ): void;
}

export class LpCanvasRendererContext implements ILpCanvasRendererContext {
  public readonly positionTransformers: ((current: Vector2CanvasNormalized, origin: Vector2CanvasNormalized) => Vector2CanvasNormalized)[];

  public constructor() {
    this.positionTransformers = [];
  }

  public registerPositionTransformer(
    transformer: (current: Vector2CanvasNormalized, origin: Vector2CanvasNormalized) => Vector2CanvasNormalized,
  ): void {
    this.positionTransformers.push(transformer);
  }
}

export class Contexts {
  private contexts: Record<string, LpCanvasRendererContext> = {};

  public get(uid: string): LpCanvasRendererContext {
    if (!this.contexts[uid]) {
      this.contexts[uid] = new LpCanvasRendererContext();
    }
    return this.contexts[uid];
  }
}
